<script lang="ts" setup>

const props = defineProps({
    url: {
        type: String,
        required: true
    },
    thumbnail: {
        type: String,
        required: true
    }
})

</script>

<template>
    <UiDialog>

        <UiDialogTrigger as-child style="box-shadow: unset">
            <div class="w-fit h-fit relative cursor-pointer rounded-xl overflow-hidden group">
                <img :src="props.thumbnail" class="w-[125px] h-[125px] object-cover group-hover:blur-sm transition-all">
                <div class="overlay absolute top-0 bottom-0 right-0 left-0 bg-white hover:bg-opacity-70 bg-opacity-0 transition-all">
                    <Icon class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-primary-500 transition-all opacity-0 group-hover:opacity-100" name="ri:zoom-in-line"
                          size="24px"/>
                </div>
            </div>
        </UiDialogTrigger>

        <UiDialogContent
                class="bg-opacity-0 overflow-hidden shadow-none border-0 min-w-[500px] max-w-fit max-h-fit w-2/3 flex items-center justify-center py-7 px-5">
            <div class="bg-white w-full h-full rounded-2xl overflow-hidden">
                <img :src="props.url" class="shadow w-full h-full rounded-xl">
            </div>
            <UiDialogClose class="absolute text-2xl top-1 right-1">&times;</UiDialogClose>
        </UiDialogContent>
    </UiDialog>
</template>